
import { Component, Mixins, Prop } from "vue-property-decorator";
import { VuetifyMixin } from "@/mixins/VuetifyMixin";
import { SocialMediaField } from '@/../types/interfaces';
import { mdiCloseCircle, mdiPlus, mdiChevronDown } from '@mdi/js';
import { SocialMedia, SocialMediaKeys } from '@/../types/enums';

type Item<T> = {
	text: string;
	value: T;
};

@Component
export class SocialMediaInput extends Mixins(VuetifyMixin) {
	mdiCloseCircle = mdiCloseCircle;
	mdiPlus = mdiPlus;
	mdiChevronDown = mdiChevronDown;

	@Prop() value: SocialMediaField[];

	get Value(): SocialMediaField[]{
		return this.value;
	}
	set Value(newValue: SocialMediaField[]) {
		this.$emit('input', newValue);
	}

	get platformItems(): Item<SocialMedia>[] {
		let items: Item<SocialMedia>[] = [];

		Object.keys(SocialMedia)
			.filter(x => !(parseInt(x) >= 0))
			.forEach(media_key => {
				items.push({
					text: media_key as SocialMediaKeys,
					value: SocialMedia[media_key]
				});
			});
		return items;
	}
}
export default SocialMediaInput;
